const profileMenuRegex = /restaurantes\/(.*)\/(.*-menu)/g;
const sectionMenuRegex = /\/restaurantes\/(.+)\/(.+)-menu\/seccion\/(.+)/;

export const isShopList = (route, search) => {
  if (route && search) {
    return !!search.lat && !!search.lng && route.includes('restaurantes');
  }
  return false;
};

export default function groupTransactions(pathname, search) {
  try {
    if (!pathname) return 'Undefined transaction';

    if (isShopList(pathname, search)) {
      return '/restaurantes/:shop-list';
    }

    return pathname
      .replace(profileMenuRegex, 'restaurantes/:city/:profile-menu')
      .replace(
        sectionMenuRegex,
        'restaurantes/:city/:profile-menu/seccion/:section-id',
      );
  } catch (error) {
    console.error(error);
    return '';
  }
}
